<template>
    <el-button
            style="float: left"
            type="warning"
            :disabled="!isReverseVerify"
            :loading="reserveVerifyLoading"
            @click="reserveVerifyCraft"
            icon="el-icon-user"
            size="mini">反审
    </el-button>
</template>

<script>
    import {mapMutations, mapState} from 'vuex'

    export default {
        name: "ReserveVerifyCurrentCraftBtn",
        data() {
            return {reserveVerifyLoading: false}
        },
        props: {
            isReverseVerify: {type: Boolean, required: true},
            checkReserveVerify: {
                type: Function,
                default: function () {
                    return () => {
                        return true
                    }
                }
            },
        },
        computed: {
            ...mapState(['currentCraft'])
        },
        methods: {
            // 反审
            // 完成后需要将 Group 进行更新
            reserveVerifyCraft() {
                if (!this.checkReserveVerify()) {
                    return
                }

                const url = `${this.$const.craftListUrl}${this.currentCraft.id}/reverse_verify/`
                this.reserveVerifyLoading = true

                this.$postRequest(url).then((response) => {
                    this.reserveVerifyLoading = false
                    this.$message.success('反审成功')
                    const craft_record = response.data
                    this.updateCurrentCraft(craft_record) // 更新 currentCraft
                }).catch((error) => {
                    this.reserveVerifyLoading = false
                })

            },
            ...mapMutations(['updateCurrentCraft'])
        },
    }
</script>

<style scoped>

</style>